import { API_URL } from '../config/config';
import BaseRequest from './BaseRequest';

const BASE_URL = `${API_URL}/my-pergamum`

const resolveHeaders = () => {
    try {
        const privateHeaders = BaseRequest.privateHeaders;

        if (typeof privateHeaders === 'function') {
            const headers = privateHeaders();
            if (headers) {
                return headers;
            }
        } else if (privateHeaders) {
            return privateHeaders;
        }
    } catch (error) {
        // Fallback para não interromper fluxos de login sem token (estava quebrando a auth OAuth2)
    }

    return BaseRequest.publicHeaders;
};

const MyPergamumRequest = () => ({
    saveLog: (acaoTela) => {
        return BaseRequest.axiosInst.post(
            `${BASE_URL}/access-log/${acaoTela}`,
            {},
            { headers: { ...resolveHeaders() } },
        );
    }
})

export default MyPergamumRequest();
